// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "8ed46b69c39f17f00bda91b4515063e0bb655650/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};